module.exports = __webpack_public_path__ + "static/media/tracking5.3fe683a4.png";